<template>
  <div v-if="info && info.user_name" class="jin-m-base">
    <div class="jin-m-base-info">
      <p class="name">{{ info.user_name }}</p>
      <ul>
        <li>手机 ·  <span>{{ info.phone_number }}</span></li>
        <li>邮箱 ·  <span>{{ info.email }}</span></li>
        <li v-if="info.expect_salary">期望薪资 · <span>{{ info.expect_salary }}</span></li>
      </ul>
    </div>
    <img v-if="info.avatar" :src="info.avatar" alt="">
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default: null
    }
  },
  data() {
    return {

    }
  }
}
</script>

<style lang="scss" scoped>
.jin-m {
  &-base {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;

    &-info {
      .name {
        font-size: 15px;
        color: #3d4351;
        line-height: 18px;
        margin-bottom: 11px;
      }

      ul {
        li {
          font-size: 13px;
          font-weight: 400;
          color: #3d4351;
          line-height: 18px;
          margin-bottom: 2px;

          span {
            color: #787b8a;
          }
        }
      }
    }

    img {
      width: 72px;
      height: 72px;
      border-radius: 2px;
      object-fit: cover;
    }
  }
}
</style>
